module.exports = __webpack_public_path__ + "static/media/Eje-Herramienta-Superior.83e8ae11.jpg";